<template>
  <HomePage :categories="categories" />
</template>

<script>
import HomePage from '../components/HomePage.vue'

export default {
  name: 'HomeView',
  components: { HomePage },
  props: {
    categories: { type: Array, default: () => [] }
  }
}
</script>
